"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var AnalyzePole = /*#__PURE__*/function () {
  function AnalyzePole(section, ansiDiameter) {
    _classCallCheck(this, AnalyzePole);
    _defineProperty(this, "section", void 0);
    _defineProperty(this, "poleDiameter", void 0);
    _defineProperty(this, "ansiDiameter", void 0);
    _defineProperty(this, "toPercent", function (val) {
      return "".concat((val * 100).toFixed(1), "%");
    });
    _defineProperty(this, "roundToString", function (val) {
      return "".concat(val.toFixed(1));
    });
    _defineProperty(this, "round", function (val) {
      return Number(val.toFixed(1));
    });
    this.damages = section.damages;
    this.poleDiameter = section.diameter;
    this.ansiDiameter = ansiDiameter;
    var PI = Math.PI;
    this.momentSlopePole = PI * (Math.pow(this.poleDiameter, 3) / 32);
    this.momentInertiaPole = PI * (Math.pow(this.poleDiameter, 4) / 64);
    this.areaPole = PI * (Math.pow(this.poleDiameter, 2) / 4);
    this.momentSlopeANSI = PI * (Math.pow(ansiDiameter, 3) / 32);
    this.momentInertiaANSI = PI * (Math.pow(ansiDiameter, 4) / 64);
    this.areaANSI = PI * (Math.pow(ansiDiameter, 2) / 4);
  }
  _createClass(AnalyzePole, [{
    key: "makeLabels",
    value: function makeLabels(values, baseLabels) {
      return values.reduce(function (labels, value, i) {
        labels.push(baseLabels[i]);
        if (value.original) labels.push("(Original ".concat(baseLabels[i].replace(':', ''), "):"));
        if (value.ansi) labels.push("(ANSI ".concat(baseLabels[i].replace(':', ''), "):"));
        return labels;
      }, []);
    }
  }, {
    key: "calculateForAPI",
    value: function calculateForAPI(raw) {
      var actualValues = this.calculateActual(raw);
      return {
        actual: {
          momentSlopeY: raw['momentSlopeY'],
          momentSlopeX: raw['momentSlopeX'],
          momentInertiaX: raw['momentInertiaX'],
          momentInertiaY: raw['momentInertiaY'],
          area: raw['area']
        },
        original: {
          momentSlopeY: actualValues['originalMomentSlopeX'],
          momentSlopeX: actualValues['originalMomentSlopeY'],
          momentInertiaX: actualValues['originalMomentInertiaX'],
          momentInertiaY: actualValues['originalMomentInertiaY'],
          area: actualValues['originalArea']
        },
        ansi: {
          momentSlopeY: actualValues['ansiMomentSlopeX'],
          momentSlopeX: actualValues['ansiMomentSlopeY'],
          momentInertiaX: actualValues['ansiMomentInertiaX'],
          momentInertiaY: actualValues['ansiMomentInertiaY'],
          area: actualValues['ansiArea']
        }
      };
    }
  }, {
    key: "__calculateSectionPercent",
    value: function __calculateSectionPercent(_ref) {
      var momentSlopeX = _ref.momentSlopeX,
        momentSlopeY = _ref.momentSlopeY,
        momentInertiaX = _ref.momentInertiaX,
        momentInertiaY = _ref.momentInertiaY,
        area = _ref.area;
      var result = {};
      if (this.poleDiameter) {
        result['polePercentSlopeY'] = this.toPercent(momentSlopeY / this.momentSlopePole);
        result['polePercentSlopeX'] = this.toPercent(momentSlopeX / this.momentSlopePole);
        result['polePercentMomentY'] = this.toPercent(momentInertiaY / this.momentInertiaPole);
        result['polePercentMomentX'] = this.toPercent(momentInertiaX / this.momentInertiaPole);
        result['polePercentArea'] = this.toPercent(area / this.areaPole);
      }
      if (this.ansiDiameter) {
        result['ansiPercentSlopeY'] = this.toPercent(momentSlopeY / this.momentSlopeANSI);
        result['ansiPercentSlopeX'] = this.toPercent(momentSlopeX / this.momentSlopeANSI);
        result['ansiPercentMomentY'] = this.toPercent(momentInertiaY / this.momentInertiaANSI);
        result['ansiPercentMomentX'] = this.toPercent(momentInertiaX / this.momentInertiaANSI);
        result['ansiPercentArea'] = this.toPercent(area / this.areaANSI);
      }
      return {
        result: result
      };
    }
  }, {
    key: "makeLabelsAndArrays",
    value: function makeLabelsAndArrays(valuesToReduce, key, inputLabels, result) {
      var labels = this.makeLabels(valuesToReduce, inputLabels);
      valuesToReduce = valuesToReduce.reduce(function (values, value) {
        return [].concat(_toConsumableArray(values), _toConsumableArray(Object.values(value)));
      }, []);
      return _defineProperty(_defineProperty({
        labels: labels
      }, key, valuesToReduce), "result", result);
    }
  }, {
    key: "calculatePercent",
    value: function calculatePercent(section) {
      var _this$__calculateSect = this.__calculateSectionPercent(section),
        result = _this$__calculateSect.result;
      return result;
    }
  }, {
    key: "calculateActual",
    value: function calculateActual(_ref3) {
      var momentSlopeX = _ref3.momentSlopeX,
        momentSlopeY = _ref3.momentSlopeY,
        momentInertiaX = _ref3.momentInertiaX,
        momentInertiaY = _ref3.momentInertiaY,
        area = _ref3.area;
      var result = {};
      if (this.poleDiameter) {
        result['originalMomentSlopeY'] = this.round(this.momentSlopePole);
        result['originalMomentSlopeX'] = this.round(this.momentSlopePole);
        result['originalMomentInertiaY'] = this.round(this.momentInertiaPole);
        result['originalMomentInertiaX'] = this.round(this.momentInertiaPole);
        result['originalArea'] = this.round(this.areaPole);
        result['poleActualMomentSlopeY'] = this.round(momentSlopeY);
        result['poleActualMomentSlopeX'] = this.round(momentSlopeX);
        result['poleActualMomentInertiaY'] = this.round(momentInertiaY);
        result['poleActualMomentInertiaX'] = this.round(momentInertiaX);
        result['poleArea'] = this.round(area);
      }
      if (this.ansiDiameter) {
        result['ansiMomentSlopeY'] = this.round(this.momentSlopeANSI);
        result['ansiMomentSlopeX'] = this.round(this.momentSlopeANSI);
        result['ansiMomentInertiaY'] = this.round(this.momentInertiaANSI);
        result['ansiMomentInertiaX'] = this.round(this.momentInertiaANSI);
        result['ansiArea'] = this.round(this.areaANSI);
      } else {
        result['ansiMomentSlopeY'] = 0;
        result['ansiMomentSlopeX'] = 0;
        result['ansiMomentInertiaY'] = 0;
        result['ansiMomentInertiaX'] = 0;
        result['ansiArea'] = 0;
      }
      return result;
    }
  }, {
    key: "calculateStrength",
    value: function calculateStrength(_ref4) {
      var momentSlopeX = _ref4.momentSlopeX,
        momentSlopeY = _ref4.momentSlopeY;
      var fiberStrength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var result = {};
      var strength = [{}, {}];
      if (this.poleDiameter) {
        result['polePercentX'] = this.toPercent(momentSlopeX / this.momentSlopePole);
        result['polePercentY'] = this.toPercent(momentSlopeY / this.momentSlopePole);
        result['poleStrengthX'] = Math.round(momentSlopeX / this.momentSlopePole * fiberStrength);
        result['poleStrengthY'] = Math.round(momentSlopeY / this.momentSlopePole * fiberStrength);
        strength[0].pole = [result['polePercentY'], result['polePercentX']];
        strength[1].pole = [result['poleStrengthY'], result['poleStrengthX']];
      }
      if (this.ansiDiameter) {
        result['ansiPercentX'] = this.toPercent(momentSlopeX / this.momentSlopeANSI);
        result['ansiPercentY'] = this.toPercent(momentSlopeY / this.momentSlopeANSI);
        result['ansiStrengthX'] = Math.round(momentSlopeX / this.momentSlopeANSI * fiberStrength);
        result['ansiStrengthY'] = Math.round(momentSlopeY / this.momentSlopeANSI * fiberStrength);
        strength[0].ansi = [result['ansiPercentY'], result['ansiPercentX']];
        strength[1].ansi = ["(".concat(result['ansiStrengthY'], ")"), "(".concat(result['ansiStrengthX'], ")")];
      }
      return this.makeLabelsAndArrays(strength, 'strength', ["Section Modulus Remaining:", "Remaining Strength (psi):"], result);
    }
  }]);
  return AnalyzePole;
}();
var _default = exports["default"] = AnalyzePole;